export const getFunnelLoginLink = (postIntroUrl: string) =>
  `https://www.wix.com/intro/studio?ref=app_studio_login&postIntroUrl=${postIntroUrl}`;

export const getFunnelSignUpLink = (postIntroUrl: string) =>
  `https://www.wix.com/intro/studio?ref=app_studio_signup&postIntroUrl=${postIntroUrl}`;
